import React from "react";
import { states } from "../../config/questionOptions";

import Button from "../../../Button/Button";
import QuestionRadioGroup from "../../../Form/QuestionRadioGroup";
import ResourcesCards from "../../../Resources/ResourcesCards";
import arrowIcon from "../../../../assets/arrow-down.svg";

import styles from "./GuidedIntro.module.scss";

const GuidedIntro: React.FC<any> = ({ headline, description, featuredPublication, isSave }) => {
  return (
    <div className="formTypographyWrapper">
      <div className="container formSection" style={{ backgroundColor: "#F7F5F0" }}>
        <h1 className="h2" style={{ marginBottom: "16px" }}>
          {headline}
        </h1>
        <p style={{ marginBottom: "42px", maxWidth: "470px" }}>{description}</p>
        <QuestionRadioGroup name="location" options={states} className={styles.radioGroup} />
        <div className="buttonSpacing">
          <Button
            onClick={() => {
              window.toggleGatewayForm("guided-step-two");
              // analytics.stepCompleted("guided-step-one", "1", values);
              // setCurrentStep("guided-step-two");
            }}
            text="Start guided search"
            secondaryText="Step 1 of 3"
          />
        </div>
        <div className={styles.browseAllResources}>
          or, <a href="#browse-all">browse all resources</a> <img src={arrowIcon} alt="arrow-down-icon" />
        </div>
      </div>
      <div>
        {!isSave ? <ResourcesCards featuredPublication={featuredPublication} collectionView /> : null}
      </div>
    </div>
  );
};

export default GuidedIntro;
